/**
 * Dropdown tombol cetak (📄) di tabel transaksi keluar.
 *
 * Dikontrol Vue sendiri, tidak lewat data-toggle="dropdown" Bootstrap JS dari
 * CDN (kalau CDN itu mati, tombolnya ikut tidak bisa diklik). Menu diposisikan
 * `fixed` dari posisi tombol supaya tidak terpotong overflow .table-responsive.
 *
 * Pemakaian di template:
 *   <button @click.stop="toggleDropdown($event, item.id)" ...>
 *   <div class="dropdown-menu dropdown-menu-right"
 *        :class="{ show: dropdownAktif == item.id }" :style="dropdownStyle">
 */
const TINGGI_MENU = 200;

export default {
    data() {
        return {
            dropdownAktif: null,
            dropdownStyle: {},
        };
    },
    mounted() {
        document.addEventListener('click', this.tutupDropdown);
        window.addEventListener('scroll', this.tutupDropdown, true);
        window.addEventListener('resize', this.tutupDropdown);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.tutupDropdown);
        window.removeEventListener('scroll', this.tutupDropdown, true);
        window.removeEventListener('resize', this.tutupDropdown);
    },
    methods: {
        toggleDropdown(event, id) {
            if (this.dropdownAktif === id) {
                this.tutupDropdown();
                return;
            }
            const rect  = event.currentTarget.getBoundingClientRect();
            const style = {
                position: 'fixed',
                right: (window.innerWidth - rect.right) + 'px',
                left: 'auto',
                transform: 'none',
                zIndex: 1050,
            };
            // Tombol dekat bawah layar: buka menu ke atas
            if (rect.bottom + TINGGI_MENU > window.innerHeight) {
                style.top    = 'auto';
                style.bottom = (window.innerHeight - rect.top + 2) + 'px';
            } else {
                style.top    = (rect.bottom + 2) + 'px';
            }
            this.dropdownStyle = style;
            this.dropdownAktif = id;
        },
        tutupDropdown() {
            this.dropdownAktif = null;
        },
    },
};
